var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

!function webpackUniversalModuleDefinition(e, p) {
  "object" == typeof exports && "object" == typeof module ? module.exports = p() : "function" == typeof define && define.amd ? define([], p) : "object" == typeof exports ? exports["@wordpress/autop"] = p() : (e.wp = e.wp || {}, e.wp.autop = p());
}(self, function () {
  return function () {
    "use strict";

    var e = {};
    return function () {
      var p = e;
      Object.defineProperty(p, "__esModule", {
        value: !0
      }), p.autop = function autop(e) {
        var p = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        var n = [];
        if ("" === e.trim()) return "";

        if (-1 !== (e += "\n").indexOf("<pre")) {
          var _p = e.split("</pre>"),
              _r = _p.pop();

          e = "";

          for (var _r2 = 0; _r2 < _p.length; _r2++) {
            var _t = _p[_r2],
                c = _t.indexOf("<pre");

            if (-1 === c) {
              e += _t;
              continue;
            }

            var l = "<pre wp-pre-tag-" + _r2 + "></pre>";
            n.push([l, _t.substr(c) + "</pre>"]), e += _t.substr(0, c) + l;
          }

          e += _r;
        }

        e = e.replace(/<br\s*\/?>\s*<br\s*\/?>/g, "\n\n");
        var r = "(?:table|thead|tfoot|caption|col|colgroup|tbody|tr|td|th|div|dl|dd|dt|ul|ol|li|pre|form|map|area|blockquote|address|math|style|p|h[1-6]|hr|fieldset|legend|section|article|aside|hgroup|header|footer|nav|figure|figcaption|details|menu|summary)";
        -1 !== (e = replaceInHtmlTags(e = (e = (e = e.replace(new RegExp("(<" + r + "[\\s/>])", "g"), "\n\n$1")).replace(new RegExp("(</" + r + ">)", "g"), "$1\n\n")).replace(/\r\n|\r/g, "\n"), {
          "\n": " \x3c!-- wpnl --\x3e "
        })).indexOf("<option") && (e = (e = e.replace(/\s*<option/g, "<option")).replace(/<\/option>\s*/g, "</option>"));
        -1 !== e.indexOf("</object>") && (e = (e = (e = e.replace(/(<object[^>]*>)\s*/g, "$1")).replace(/\s*<\/object>/g, "</object>")).replace(/\s*(<\/?(?:param|embed)[^>]*>)\s*/g, "$1"));
        -1 === e.indexOf("<source") && -1 === e.indexOf("<track") || (e = (e = (e = e.replace(/([<\[](?:audio|video)[^>\]]*[>\]])\s*/g, "$1")).replace(/\s*([<\[]\/(?:audio|video)[>\]])/g, "$1")).replace(/\s*(<(?:source|track)[^>]*>)\s*/g, "$1"));
        -1 !== e.indexOf("<figcaption") && (e = (e = e.replace(/\s*(<figcaption[^>]*>)/, "$1")).replace(/<\/figcaption>\s*/, "</figcaption>"));
        var t = (e = e.replace(/\n\n+/g, "\n\n")).split(/\n\s*\n/).filter(Boolean);
        e = "", t.forEach(function (p) {
          e += "<p>" + p.replace(/^\n*|\n*$/g, "") + "</p>\n";
        }), e = (e = (e = (e = (e = (e = (e = (e = e.replace(/<p>\s*<\/p>/g, "")).replace(/<p>([^<]+)<\/(div|address|form)>/g, "<p>$1</p></$2>")).replace(new RegExp("<p>\\s*(</?" + r + "[^>]*>)\\s*</p>", "g"), "$1")).replace(/<p>(<li.+?)<\/p>/g, "$1")).replace(/<p><blockquote([^>]*)>/gi, "<blockquote$1><p>")).replace(/<\/blockquote><\/p>/g, "</p></blockquote>")).replace(new RegExp("<p>\\s*(</?" + r + "[^>]*>)", "g"), "$1")).replace(new RegExp("(</?" + r + "[^>]*>)\\s*</p>", "g"), "$1"), p && (e = (e = (e = (e = e.replace(/<(script|style).*?<\/\\1>/g, function (e) {
          return e[0].replace(/\n/g, "<WPPreserveNewline />");
        })).replace(/<br>|<br\/>/g, "<br />")).replace(/(<br \/>)?\s*\n/g, function (e, p) {
          return p ? e : "<br />\n";
        })).replace(/<WPPreserveNewline \/>/g, "\n"));
        e = (e = (e = e.replace(new RegExp("(</?" + r + "[^>]*>)\\s*<br />", "g"), "$1")).replace(/<br \/>(\s*<\/?(?:p|li|div|dl|dd|dt|th|pre|td|ul|ol)[^>]*>)/g, "$1")).replace(/\n<\/p>$/g, "</p>"), n.forEach(function (p) {
          var _p2 = _slicedToArray(p, 2),
              n = _p2[0],
              r = _p2[1];

          e = e.replace(n, r);
        }), -1 !== e.indexOf("\x3c!-- wpnl --\x3e") && (e = e.replace(/\s?<!-- wpnl -->\s?/g, "\n"));
        return e;
      }, p.removep = function removep(e) {
        var p = "blockquote|ul|ol|li|dl|dt|dd|table|thead|tbody|tfoot|tr|th|td|h[1-6]|fieldset|figure",
            n = p + "|div|p",
            r = p + "|pre",
            t = [];
        var c = !1,
            l = !1;
        if (!e) return "";
        -1 === e.indexOf("<script") && -1 === e.indexOf("<style") || (e = e.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/g, function (e) {
          return t.push(e), "<wp-preserve>";
        }));
        -1 !== e.indexOf("<pre") && (c = !0, e = e.replace(/<pre[^>]*>[\s\S]+?<\/pre>/g, function (e) {
          return (e = (e = e.replace(/<br ?\/?>(\r\n|\n)?/g, "<wp-line-break>")).replace(/<\/?p( [^>]*)?>(\r\n|\n)?/g, "<wp-line-break>")).replace(/\r?\n/g, "<wp-line-break>");
        }));
        -1 !== e.indexOf("[caption") && (l = !0, e = e.replace(/\[caption[\s\S]+?\[\/caption\]/g, function (e) {
          return e.replace(/<br([^>]*)>/g, "<wp-temp-br$1>").replace(/[\r\n\t]+/, "");
        }));
        -1 !== (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace(new RegExp("\\s*</(" + n + ")>\\s*", "g"), "</$1>\n")).replace(new RegExp("\\s*<((?:" + n + ")(?: [^>]*)?)>", "g"), "\n<$1>")).replace(/(<p [^>]+>[\s\S]*?)<\/p>/g, "$1</p#>")).replace(/<div( [^>]*)?>\s*<p>/gi, "<div$1>\n\n")).replace(/\s*<p>/gi, "")).replace(/\s*<\/p>\s*/gi, "\n\n")).replace(/\n[\s\u00a0]+\n/g, "\n\n")).replace(/(\s*)<br ?\/?>\s*/gi, function (e, p) {
          return p && -1 !== p.indexOf("\n") ? "\n\n" : "\n";
        })).replace(/\s*<div/g, "\n<div")).replace(/<\/div>\s*/g, "</div>\n")).replace(/\s*\[caption([^\[]+)\[\/caption\]\s*/gi, "\n\n[caption$1[/caption]\n\n")).replace(/caption\]\n\n+\[caption/g, "caption]\n\n[caption")).replace(new RegExp("\\s*<((?:" + r + ")(?: [^>]*)?)\\s*>", "g"), "\n<$1>")).replace(new RegExp("\\s*</(" + r + ")>\\s*", "g"), "</$1>\n")).replace(/<((li|dt|dd)[^>]*)>/g, " \t<$1>")).indexOf("<option") && (e = (e = e.replace(/\s*<option/g, "\n<option")).replace(/\s*<\/select>/g, "\n</select>"));
        -1 !== e.indexOf("<hr") && (e = e.replace(/\s*<hr( [^>]*)?>\s*/g, "\n\n<hr$1>\n\n"));
        -1 !== e.indexOf("<object") && (e = e.replace(/<object[\s\S]+?<\/object>/g, function (e) {
          return e.replace(/[\r\n]+/g, "");
        }));
        e = (e = (e = (e = e.replace(/<\/p#>/g, "</p>\n")).replace(/\s*(<p [^>]+>[\s\S]*?<\/p>)/g, "\n$1")).replace(/^\s+/, "")).replace(/[\s\u00a0]+$/, ""), c && (e = e.replace(/<wp-line-break>/g, "\n"));
        l && (e = e.replace(/<wp-temp-br([^>]*)>/g, "<br$1>"));
        t.length && (e = e.replace(/<wp-preserve>/g, function () {
          return t.shift();
        }));
        return e;
      };
      var n = new RegExp("(<((?=!--|!\\[CDATA\\[)((?=!-)!(?:-(?!->)[^\\-]*)*(?:--\x3e)?|!\\[CDATA\\[[^\\]]*(?:](?!]>)[^\\]]*)*?(?:]]>)?)|[^>]*>?))");

      function replaceInHtmlTags(e, p) {
        var r = function htmlSplit(e) {
          var p = [];
          var r,
              t = e;

          for (; r = t.match(n);) {
            var _e = r.index;
            p.push(t.slice(0, _e)), p.push(r[0]), t = t.slice(_e + r[0].length);
          }

          return t.length && p.push(t), p;
        }(e);

        var t = !1;
        var c = Object.keys(p);

        for (var _e2 = 1; _e2 < r.length; _e2 += 2) {
          for (var _n = 0; _n < c.length; _n++) {
            var l = c[_n];

            if (-1 !== r[_e2].indexOf(l)) {
              r[_e2] = r[_e2].replace(new RegExp(l, "g"), p[l]), t = !0;
              break;
            }
          }
        }

        return t && (e = r.join("")), e;
      }
    }(), e;
  }();
});